import React, { useEffect, useState } from "react";
import { getUserData } from "../../utils/localStorage";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { Link, useNavigate } from "react-router-dom";
import { getBrandPriceCode } from "../../services/getPriceCode";
import { getBrandOffer } from "../../services/getBrandOffers";
import AdminMenu from "../../pages/AdminMenu";
import {
  IndianRupee,
  Ruler,
  Layers,
  Download,
  UploadCloud,
  FileSpreadsheet,
  X,
  ArrowRight,
  Gift,
} from "lucide-react";

// ---- design tokens -------------------------------------------------------
const brand = "#1752AA";
const brandBg = "#EAF1FB";
const ink = "#1A2433";
const slate = "#5C6B7A";
const line = "#E1E6EE";
const paper = "#F5F7FB";
const danger = "#C0392B";

const styles = {
  page: {
    background: paper,
    minHeight: "calc(100vh - 3rem)",
    padding: "28px 0 48px",
  },
  wrap: { maxWidth: 1080, margin: "0 auto", padding: "0 16px" },
  card: {
    background: "#fff",
    border: `1px solid ${line}`,
    borderRadius: 14,
    padding: 24,
    marginBottom: 20,
    boxShadow: "0 1px 3px rgba(16, 24, 40, 0.06)",
  },
  cardHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 20,
  },
  step: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 26,
    height: 26,
    borderRadius: "50%",
    background: brand,
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    marginRight: 10,
    flexShrink: 0,
  },
  cardTitle: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600,
    color: ink,
    display: "flex",
    alignItems: "center",
  },
  cardSub: { margin: "6px 0 0 36px", fontSize: 14, color: slate },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 20,
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 14,
    fontWeight: 600,
    color: ink,
    marginBottom: 8,
  },
  iconTile: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    height: 28,
    borderRadius: 8,
    background: brandBg,
    color: brand,
  },
  error: { color: danger, fontSize: 13, marginTop: 6, minHeight: 18 },
  primaryBtn: (disabled) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 22px",
    borderRadius: 8,
    border: "none",
    background: disabled ? "#9DB3D6" : brand,
    color: "#fff",
    fontWeight: 600,
    fontSize: 15,
    cursor: disabled ? "not-allowed" : "pointer",
  }),
  outlineBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "9px 16px",
    borderRadius: 8,
    border: `1px solid ${brand}`,
    background: "#fff",
    color: brand,
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  },
  dropzone: (disabled, dragging) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "32px 16px",
    borderRadius: 12,
    border: `2px dashed ${dragging ? brand : line}`,
    background: disabled ? "#FAFBFC" : dragging ? brandBg : "#fff",
    color: disabled ? "#A0AAB6" : slate,
    textAlign: "center",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "background 0.15s, border-color 0.15s",
  }),
  fileRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 14px",
    borderRadius: 10,
    border: `1px solid ${line}`,
    background: paper,
    marginTop: 14,
  },
};

const OfferManagement = () => {
  const navigate = useNavigate();

  const userData = getUserData();
  let brandId = userData.brandProfileData.id;

  const [brandPriceList, setBrandPriceList] = useState([]);
  const [offerList, setOfferList] = useState([]);
  const [filteredOfferList, setFilteredOfferList] = useState([]);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [visible, setVisible] = useState(false);

  const [input, setInput] = useState({
    offers: "",
  });
  const [errors, setErrors] = useState({
    priceId:"",
    offers: "",
  });
 
  const fetchGetBrandPriceCode = () => {
    getBrandPriceCode(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const filteredData = res.prices.filter(
            (price) => price.status === true
          );
          const priceList = filteredData.map((item) => ({
            label: item.priceCode,
            value: item.id,
          }));
          setBrandPriceList(priceList);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getBrandOffer(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          
          const offers = res.map((item) => ({
            ...item,
            label: item.name,
            value: item,
            priceId: item.priceId,
          }));
          setOfferList(offers);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchGetBrandPriceCode();
  }, []);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (input.priceId === "") {
      newErrors.priceId = "Please select any Tariff List";
      isValid = false;
    } else {
      newErrors.priceId = "";
    }
    if (input.offers === "") {
      newErrors.offers = "Please select any Offer";
      isValid = false;
    } else {
      newErrors.offers = "";
    }
    setErrors(newErrors);
    return isValid;
  };

  const handlePriceChange = (e) => {
    const selectedPriceId = e.target.value;
    setInput({ ...input, priceId: selectedPriceId });
    const filteredOffers = offerList.filter(
      (offer) => offer.priceId === selectedPriceId
    );
    setFilteredOfferList(filteredOffers);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitButtonPressed(true);
    if (validateForm()) {
      let data = {
        offers: input.offers,
        priceId: input.priceId,
      };

      navigate("/my-offer-garment-selection", {
        state: {
          offerId: input.offers.id,
          offerName: input.offers.name,
          priceId: input.priceId,
        },
      });

    } else {
      setSubmitButtonPressed(false);
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{ "--surface-0": brand }}
      >
        <div className="flex-1 flex align-items-center ml-3 mr-3">
          <i
            className="pi pi-angle-left mx-3"
            onClick={() => navigate("/TariffManagement")}
            style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
          ></i>
          <p className="flex-1 ml-4 m-0 text-2xl text-white font-bold uppercase">
            Offer Garment Management
          </p>
          <i
            className="pi pi-bars"
            onClick={() => setVisible(true)}
            style={{
              fontSize: "27px",
              marginRight: 30,
              color: "#fff",
              cursor: "pointer",
            }}
          ></i>
        </div>
      </div>

      <div style={styles.page}>
        <div style={styles.wrap}>
           
          {/* Step 1: configuration */}
          <form onSubmit={handleSubmit} style={styles.card}>
            <div style={styles.cardHead}>
              <div>
                <h4 style={styles.cardTitle}>
                  <span style={styles.step}>1</span>
                  Configure Offers
                </h4>
                <p style={styles.cardSub}>All three fields are required.</p>
              </div>
            </div>

            <div style={styles.grid}>
              <div>
                <label style={styles.label}>
                  <span style={styles.iconTile}>
                    <Gift size={16} />
                  </span>
                  Tariff List
                </label>
                <Dropdown
                  value={input.priceId}
                  options={brandPriceList}
                  onChange={handlePriceChange}
                  placeholder="Select a Tariff List"
                  filter={brandPriceList.length > 8}
                  className={errors.priceId ? "p-invalid" : ""}
                  style={{ width: "100%" }}
                />
                <div style={styles.error}>{errors.priceId}</div>
              </div>

              <div>
                <label style={styles.label}>
                  <span style={styles.iconTile}>
                    <Gift size={16} />
                  </span>
                  Offer List
                </label>
                <Dropdown
                  value={input.offers}
                  options={filteredOfferList}
                  onChange={(e) => {
                      setInput({
                        ...input,
                        offers: e.target.value,
                      });
                    }}
                  placeholder="Select a Offer"
                  filter={filteredOfferList.length > 8}
                  className={errors.priceId ? "p-invalid" : ""}
                  style={{ width: "100%" }}
                />
                <div style={styles.error}>{errors.offers}</div>
              </div>
               
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 8,
              }}
            >
              <button
                type="submit"
                style={styles.primaryBtn(submitButtonPressed)}
                disabled={submitButtonPressed}
              >
                {submitButtonPressed ? "Saving..." : "Save & Continue"}
                {!submitButtonPressed && <ArrowRight size={16} />}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* <footer style={{ backgroundColor: "#FBFBFB", borderTop: `1px solid ${line}` }}>
        <Container fluid>
          <Row>
            <Col>
              <Nav className="flex social-media-div justify-content-center gap-3 pt-3">
                {socialLinks.map((s) => (
                  <Link key={s.icon} to={s.to} target="_blank">
                    <i className={`pi ${s.icon}`} style={{ fontSize: "1.6rem", color: s.color }}></i>
                  </Link>
                ))}
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-center p-3" style={{ fontSize: 14, color: slate }}>
                &copy; {new Date().getFullYear()} Copyright:{" "}
                <a className="text-dark" href="https://oneindiatech.com/">
                  One India Technologies Pvt. Ltd.
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer> */}
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default OfferManagement;
